import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImageCropperComponent } from './imageCropperComponent';
var ImageCropperModule = (function () {
    function ImageCropperModule() {
    }
    ImageCropperModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule],
                    declarations: [ImageCropperComponent],
                    exports: [ImageCropperComponent]
                },] },
    ];
    /** @nocollapse */
    ImageCropperModule.ctorParameters = function () { return []; };
    return ImageCropperModule;
}());
export { ImageCropperModule };
//# sourceMappingURL=imageCropperModule.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-img-cropper/src/imageCropperModule.js
// module id = 2051
// module chunks = 3